import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    // Auto-redirect to Home after 5 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/");
        }, 10000);

        return () => clearTimeout(timer); // Cleanup on component unmount
    }, [navigate]);

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h1 style={styles.header}>404</h1>
                <p style={styles.message}>
                    Oops! The page you're looking for doesn't exist.
                </p>
                <Link to="/" style={styles.link}>Go Back Home</Link>
                <p style={styles.redirectText}>Redirecting in 10 seconds...</p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        // backgroundColor: '#f9f9f9',
        textAlign: 'center',
        padding: '10px',
    },
    content: {
        maxWidth: '400px',
        width: '100%',
        // backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        // boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
        animation: 'fadeIn 0.6s ease-out',
    },
    header: {
        fontSize: '5rem',
        color: '#3498db',
        marginBottom: '10px',
        animation: 'bounce 1.5s infinite',
    },
    message: {
        fontSize: '1.2rem',
        color: '#555',
        marginBottom: '20px',
    },
    link: {
        padding: '10px 20px',
        backgroundColor: '#3498db',
        color: '#fff',
        textDecoration: 'none',
        borderRadius: '5px',
        marginBottom: '10px',
        display: 'inline-block',
    },
    redirectText: {
        fontSize: '0.9rem',
        color: '#888',
        marginTop: '10px',
    },
    '@keyframes bounce': {
        '0%, 100%': {
            transform: 'translateY(0)',
        },
        '50%': {
            transform: 'translateY(-5px)',
        }
    },
    '@keyframes fadeIn': {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        }
    }
};

export default NotFound;
